/** Log an error directed at developers to the browser console. */

/** Log a warning directed at developers to the browser console. */
function logDsxWarning(component, message) {
  console.warn(`[@dsx/react] ${component}: ${message}`);
}

export { logDsxWarning };
